import { render, staticRenderFns } from "./DownloadsLink.vue?vue&type=template&id=1954322c&scoped=true&"
import script from "./DownloadsLink.vue?vue&type=script&lang=js&"
export * from "./DownloadsLink.vue?vue&type=script&lang=js&"
import style0 from "./DownloadsLink.vue?vue&type=style&index=0&id=1954322c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954322c",
  null
  
)

export default component.exports